import { render, staticRenderFns } from "./CourseFree.vue?vue&type=template&id=21023c87"
import script from "./CourseFree.vue?vue&type=script&lang=js"
export * from "./CourseFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports